<template>
  <card>
    <template slot="header">
      <div style="float: right">
        <base-button size="lg"  @click.native="resetNewUser();showAdduserModal = true" type="primary">
          Add new user
        </base-button>
        <base-button class="ml-2" size="lg"  @click="exportListAsCSV()" type="warning">
          Export list
        </base-button>
      </div>
      <h2 class="card-title">{{$t('users_management.users_management')}}</h2>
    </template>
    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div>
                <el-select class="filter-select mr-2" v-model="filters.region" collapse-tags placeholder="Filter by region" clearable @change="handleFilters">
                  <el-option v-for="item in filterOptions.regions" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                </el-select>
                <el-select class="filter-select mr-2" v-model="filters.role" placeholder="Filter by role" clearable @change="handleFilters">
                  <el-option v-for="item in filterOptions.roles" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                </el-select>
              </div>

              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData">
              <el-table-column
                sortable
                label="Name"
                property="name"
                prop="name"
              ></el-table-column>
              <el-table-column
                sortable
                label="Email"
                min-width="100"
                property="email"
              ></el-table-column>
              <el-table-column
                sortable
                label="Phone"
                property="phone"
              ></el-table-column>
              <el-table-column
                sortable
                label="Region"
                property="region"
              ></el-table-column>
              <el-table-column
                sortable
                label="Role"
                property="role"
              >
                <div slot-scope="props">
                  <span v-if="props.row.role === UserRoles.ADMIN" class="badge badge-primary">{{props.row.role.replace('_', ' ')}}</span>
                  <span v-if="props.row.role === UserRoles.REGIONAL_ADMIN" class="badge badge-info">{{props.row.role.replace('_', ' ')}}</span>
                  <span v-if="props.row.role === UserRoles.AUDITOR" class="badge badge-warning">{{props.row.role.replace('_', ' ')}}</span>
                  <span v-if="props.row.role === UserRoles.APPLICANT" class="badge badge-default">{{props.row.role.replace('_', ' ')}}</span>
                  <span v-if="props.row.role === UserRoles.EVALUATOR" class="badge badge-success">{{props.row.role.replace('_', ' ')}}</span>
                </div>
              </el-table-column>
              <el-table-column
                sortable
                label="Organization"
                max-width="30"
                property="organization"
              ></el-table-column>
              <el-table-column
                sortable
                label="Last user action"
                max-width="30"
                property="lastLogin"
              >
                <div slot-scope="props">
                  <span v-if="props.row.lastLogin === '0000-00-00 00:00:00'">Never</span>
                  <span v-if="props.row.lastLogin !== '0000-00-00 00:00:00'">{{props.row.lastLogin}}</span>
                </div>
              </el-table-column>
              <el-table-column
                sortable
                label="Language"
                max-width="30"
                property="language"
              ></el-table-column>
              <el-table-column
                sortable
                label="Status"
                max-width="30"
                :formatter="statusFormatter"
                property="active"
              ></el-table-column>
              <el-table-column align="right" label="Actions">
                <div slot-scope="props">
                  <base-button
                    v-if="!props.row.emailVerifiedAt"
                    type="primary"
                    size="sm"
                    class="mb-1"
                    @click="verifyUserEmail(props.row)"
                  >
                    Verify Email
                  </base-button>
                  <base-button
                    type="info"
                    size="sm"
                    class="mb-1"
                    @click="viewProfile(props.row)"
                  >
                    View
                  </base-button>
                  <base-button
                    type="warning"
                    size="sm"
                    class="mb-1"
                    @click="loginUser(props.row.id)"
                  >
                    Login
                  </base-button>
                  <base-button
                    v-if="loggedUser.role === UserRoles.ADMIN"
                    type="danger"
                    size="sm"
                    class="mb-1"
                    @click="deleteUser(props.row.id)"
                  >
                  Delete
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
        <modal
          type="notice"
          :show.sync="showAdduserModal"
          modal-classes="modal-top"
        >
          <h2 slot="header" class="card-title">Add new user</h2>
          <div class="row">
            <div class="col-lg-12">
              <form @submit.prevent="addNewUser">
                <base-input
                  type="text"
                  name="newUser.email"
                  v-validate="'required|email'"
                  data-vv-as="email"
                  :error="getError('newUser.email')"
                  :label="'Email'"
                  :placeholder="'Email'"
                  v-model="newUser.email"
                >
                </base-input>
                <div class="form-group">
                  <label for="roleSelect">Role</label> <select class="form-control"
                                                               v-model="newUser.role"
                                                               name="role"
                >
                  <option :value="role" v-for="role in UserRoles" :key="role">{{role.replace('_', ' ')}}</option>
                </select>
                </div>
                <div v-if="newUser.role !== UserRoles.APPLICANT" class="form-group" :class="{'has-danger': getError('newUser.regions')}">
                  <label for="regionSelect">Regions</label>
                  <multiselect name="newUser.regions" v-model="newUser.regions" selectLabel="" selectedLabel="" deselectLabel="Clear" data-vv-as="regions" v-validate="'required'" :tag-placeholder="$t('general.please_select')" :placeholder="$t('general.please_select')" label="name" track-by="regionId" :options="regions" :multiple="true"></multiselect>
                  <label v-if="getError('newUser.regions')" class="error text-danger">{{getError('newUser.regions')}}</label>
                </div>

                <p>* User will receive an email with a confirmation link.</p>
                <div class="mb-5"></div>
                <base-button
                  class="pull-right"
                  type="primary"
                  native-type="submit"
                >Add user
                </base-button>
              </form>
            </div>
          </div>

        </modal>
      </div>
    </div>
  </card>
</template>
<script>
  import {Table, TableColumn, Select, Option} from 'element-ui';
  import {BasePagination, BaseRadio, Modal} from 'src/components';
  import Multiselect from 'vue-multiselect';
  import Fuse from 'fuse.js';
  import {ApplicationService, AdminUserService, UserService, UserRoles, TokenService, RegionService} from "@/services";

  export default {
    components: {
      BaseRadio,
      BasePagination,
      Modal,
      Multiselect,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    computed: {
      loggedUser() {
        return this.$store.getters['Auth/loggedUser'];
      },
      /***
       * Returns a page from the searched data or the whole data. Search is performed in the watch section below
       */
      queriedData() {
        let result = this.tableData;
        if (this.searchedData.length > 0) {
          result = this.searchedData;
        }
        return result.slice(this.from, this.to);
      },
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      total() {
        return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableData.length;
      },
      applicationsByRegions() {
        let vm = this;
        let applications = [];

        if (vm.newUser.regions) {
          vm.newUser.regions.forEach(function (region) {
            let filteredApplications = vm.allApplicationsLight.filter((_application) => {
              return _application.regionId === region.regionId;
            });
            applications = applications.concat(filteredApplications);
          })
        }

        if (vm.newUser.assignedApplications) {
          let removed_applications = [];
          vm.newUser.assignedApplications.forEach(function (application) {
            let filteredApplications = applications.filter((_application) => {
              return _application.applicationId === application.applicationId;
            });

            if (!filteredApplications.length) {
              removed_applications.push(application);
            }
          })

          removed_applications.forEach(function (application) {
            let applicationIndex = vm.newUser.assignedApplications.indexOf(application);
            if (applicationIndex !== -1) {
              vm.newUser.assignedApplications.splice(applicationIndex, 1);
            }
          })
        }

        return applications;
      },
      countriesByRegions() {
        let vm = this;
        let countries = [];

        if (vm.newUser.regions) {
          vm.newUser.regions.forEach(function (region) {
            countries = countries.concat(region.countries);
          })
        }

        countries = countries.sort(function (a, b) {
          var textA = a.name.toLowerCase();
          var textB = b.name.toLowerCase();

          return textA.localeCompare(textB);
        })

        if (vm.newUser.countries) {
          let removed_countries = [];
          vm.newUser.countries.forEach(function (country) {
            let filteredCountry = countries.filter((_country) => {
              return _country.countryId === country.countryId;
            });

            if (!filteredCountry.length) {
              removed_countries.push(country);
            }
          })

          removed_countries.forEach(function (country) {
            let countryIndex = vm.newUser.countries.indexOf(country);
            if (countryIndex !== -1) {
              vm.newUser.countries.splice(countryIndex, 1);
            }
          })
        }

        return countries;
      }
    },
    data() {
      return {
        UserRoles,
        showAdduserModal: false,
        allApplicationsLight: [],
        userId: 0,
        newUser: {},
        filterOptions: [],
        filters: {
          region: undefined,
          role: undefined
        },
        pagination: {
          perPage: 25,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['region', 'country', 'organisationLegalName', 'website', 'email', 'role', 'name'],
        tableData: [],
        regions: [],
        searchedData: [],
        fuseSearch: null,
        initialized: false,
      };
    },
    methods: {
      async exportListAsCSV()
      {
        let vm = this;
        let loader = vm.$loading.show();

        UserService.exportListAsCSV({
          // region_id: this.filters.regionId
        }).then(function (response)
        {
          if (response.data && response.data.success)
          {
            window.open(response.data.url, '_blank');
          }

          loader.hide();
        });
      },
      resetNewUser() {
        this.newUser = {
          access_type: 'countries',
          email: '',
          name: '',
          role: UserRoles.REGIONAL_ADMIN,
          regions: [],
          countries: [],
          applications: []
        }
        this.$validator.reset();
      },
      async addNewUser() {
        let is_valid = await this.$validator.validateAll();
        if (is_valid) {
          let vm = this;

          switch (vm.newUser.access_type) {
            case 'countries':
              vm.newUser.assignedApplications = [];
              break;

            case 'applications':
              vm.newUser.countries = [];
              break;
          }

          let loader = this.$loading.show();
          let response = await UserService.createNewUser(vm.newUser);

          loader.hide();

          if (response.data.success === true) {
            alert('User has been created, a notification email has been sent to ' + vm.newUser.email);
          } else {
            alert(response.data.message);
            return;
          }

          this.getList();

          vm.resetNewUser();
          vm.showAdduserModal = false;
        }
      },
      getError: function (fieldName) {
        return this.errors.first(fieldName);
      },
      viewProfile(data) {
        this.$router.push('/users-management/view-profile/' + data.id);
      },
      async handleFilters() {
        let vm = this;
        let loader = vm.$loading.show();
        await vm.getList();
        await vm.getFilters();
        loader.hide();
      },
      async getFilters() {
        let vm = this;
        return await UserService.getUsersFilters({
          filter_region_id: vm.filters.region,
          filter_role: vm.filters.role
        }).then((response) => {
          vm.filterOptions = response.data;
        })
      },
      async loginUser(userId) {
        let loader = this.$loading.show();
        await UserService.getToken(userId).then(function (response) {
          if (response.data.access_token !== undefined) {
            TokenService.saveToken(response.data.access_token);

            setTimeout(function () {
              window.location.href = '/';
            }, 200);
          } else {
            alert('Unable to login user');
          }
        })

        loader.hide();
      },
      async deleteUser(userId) {
        if (!confirm('Are you sure you want to delete this user and all its related data?')) {
          return;
        }

        await UserService.deleteUser({userId: userId});

        this.getList();
      },
      async verifyUserEmail(data) {
        let res = await AdminUserService.verifyUserEmail(data.id);
        if (res.data.success === true) {
          data.emailVerifiedAt = 1;
        }
        if (res.data.active === true) {
          data.active = 1;
        }
      },
      async getList() {
        let loader = this.$loading.show();
        UserService.getUsers(this.filters).then((response) => {
          this.tableData = response.data;
          this.initialized = true;
          this.initFuse();
          loader.hide();
        })
      },
      async getAllApplicationsLight() {
        let vm = this;
        await ApplicationService.getAllApplicationsLight().then(function (response) {
          vm.allApplicationsLight = response.data;
        })
      },
      initFuse() {
        this.fuseSearch = new Fuse(this.tableData, {
          keys: this.propsToSearch,
          threshold: 0.3
        });
      },
      statusFormatter(value) {
        return value.active ? 'Confirmed' : 'Pending';
      }
    },
    created() {
      this.getFilters();
      this.getList();
    },
    mounted() {
      let vm = this;
      RegionService.getRegionsWithCountries().then(function (response) {
        vm.regions = response.data;
      })
    },
    watch: {
      /**
       * Searches through the table data by a given query.
       * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
       * @param value of the query
       */
      searchQuery(value) {
        let result = this.tableData;
        if (value !== '') {
          result = this.fuseSearch.search(this.searchQuery);
        }
        this.searchedData = result;
      }
    }
  };
</script>
